import { render, staticRenderFns } from "./sub-list-primary.vue?vue&type=template&id=b86c803a&"
import script from "./sub-list-primary.vue?vue&type=script&lang=js&"
export * from "./sub-list-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports